import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createMigrate } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

// middlewares
import thunkMiddleware from 'redux-thunk'

// Import custom components
import rootReducer from '../reducers';

// custom enhancers
const enhancers = [];
const middleware = [thunkMiddleware];


const migrations = {
    0: (state) => {
        // migration clear out device state
        return {
            ...state,
            device: undefined
        }
    },
    1: (state) => {
        // migration to keep only device state
        return {
            device: state.device
        }
    }
}

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    stateReconciler: autoMergeLevel2,
    // put which all reducers you want to persist
    whitelist: ['Intl','tenant', 'user', "category","csa"],
    migrate: (state) => {
        
        return Promise.resolve(state)
    }
}

const persistedReducer = persistReducer(persistConfig, rootReducer);


if (process.env.NODE_ENV === 'development') {
    //For working redux dev tools in chrome (https://github.com/zalmoxisus/redux-devtools-extension)
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);


export default () => {
    const store = createStore(persistedReducer, {}, composedEnhancers);
    return { store, persistor: persistStore(store) };
};